(() => {
  'use strict';

  /*
   * ============================================================
   * HJ Meta Signup Tracking
   * ============================================================
   *
   * Supports:
   *
   * 1. Alia email popup
   * 2. Attentive signup popup
   *
   * Both ultimately call:
   *
   *      window.HJMetaTracking.trackSignup(email)
   *
   * Meta attribution is captured from:
   *
   *      Facebook / Instagram / Meta URLs
   *
   * and preserved in sessionStorage.
   */


  const META_ATTRIBUTION_KEY =
    'hj_meta_ad_attribution';

  const META_SIGNUP_SENT_KEY =
    'hj_meta_signup_sent';


  /*
   * ============================================================
   * 1. DETECT META TRAFFIC
   * ============================================================
   */

  function isMetaAdVisit() {
    const params =
      new URLSearchParams(window.location.search);

    const source =
      (params.get('utm_source') || '').toLowerCase();

    const medium =
      (params.get('utm_medium') || '').toLowerCase();

    const metaSources = [
      'facebook',
      'instagram',
      'fb',
      'ig',
      'meta'
    ];

    const paidMediums = [
      'paid_social',
      'paidsocial',
      'paid-social',
      'cpc'
    ];

    return (
      params.has('fbclid') ||
      (
        metaSources.includes(source) &&
        paidMediums.includes(medium)
      )
    );
  }


  /*
   * ============================================================
   * 2. CAPTURE META ATTRIBUTION
   * ============================================================
   */

  function captureMetaAdAttribution() {
    if (!isMetaAdVisit()) {
      return;
    }

    const params =
      new URLSearchParams(window.location.search);

    const attribution = {
      source:
        (
          params.get('utm_source') ||
          'meta'
        ).toLowerCase(),

      medium:
        (
          params.get('utm_medium') ||
          ''
        ).toLowerCase(),

      campaign:
        params.get('utm_campaign') || '',

      fbclid:
        params.get('fbclid') || '',

      landingPage:
        window.location.href,

      timestamp:
        Date.now()
    };

    try {
      sessionStorage.setItem(
        META_ATTRIBUTION_KEY,
        JSON.stringify(attribution)
      );

      console.log(
        '[HJ Meta] Attribution captured:',
        attribution
      );

    } catch (error) {
      console.warn(
        '[HJ Meta] Unable to store attribution:',
        error
      );
    }
  }


  /*
   * ============================================================
   * 3. GET STORED ATTRIBUTION
   * ============================================================
   */

  function getMetaAdAttribution() {
    try {
      const data =
        sessionStorage.getItem(
          META_ATTRIBUTION_KEY
        );

      if (!data) {
        return null;
      }

      return JSON.parse(data);

    } catch (error) {
      console.error(
        '[HJ Meta] Unable to read Meta attribution:',
        error
      );

      return null;
    }
  }


  /*
   * ============================================================
   * 4. EMAIL VALIDATION
   * ============================================================
   */

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      email
    );
  }


  /*
   * ============================================================
   * 5. DUPLICATE CHECK
   * ============================================================
   */

  function hasAlreadySentSignup(email) {
    try {
      const sent =
        JSON.parse(
          sessionStorage.getItem(
            META_SIGNUP_SENT_KEY
          ) || '[]'
        );

      return sent.includes(
        email.toLowerCase()
      );

    } catch (error) {
      return false;
    }
  }


  /*
   * ============================================================
   * 6. MARK SIGNUP AS SENT
   * ============================================================
   */

  function markSignupAsSent(email) {
    try {
      const sent =
        JSON.parse(
          sessionStorage.getItem(
            META_SIGNUP_SENT_KEY
          ) || '[]'
        );

      const normalizedEmail =
        email.toLowerCase();

      if (
        !sent.includes(
          normalizedEmail
        )
      ) {
        sent.push(
          normalizedEmail
        );
      }

      sessionStorage.setItem(
        META_SIGNUP_SENT_KEY,
        JSON.stringify(sent)
      );

    } catch (error) {
      console.warn(
        '[HJ Meta] Unable to mark signup as sent:',
        error
      );
    }
  }


  /*
   * ============================================================
   * 7. SEND COMPLETE REGISTRATION
   * ============================================================
   *
   * This function is PROVIDER INDEPENDENT.
   *
   * Alia can call it.
   * Attentive can call it.
   * Another provider can call it.
   *
   */

  function trackMetaSignup(email) {

    console.log(
      '[HJ Meta] trackMetaSignup()',
      email
    );


    /*
     * Get stored Meta attribution.
     */

    const attribution =
      getMetaAdAttribution();

    console.log(
      '[HJ Meta] attribution =',
      attribution
    );


    /*
     * Only track Meta-attributed visitors.
     */

    if (!attribution) {
      console.log(
        '[HJ Meta] No Meta attribution - skipping signup'
      );

      return false;
    }


    /*
     * Normalize email.
     */

    email =
      (email || '')
        .trim()
        .toLowerCase();


    /*
     * Validate email.
     */

    if (!isValidEmail(email)) {
      console.warn(
        '[HJ Meta] Invalid email - skipping signup:',
        email
      );

      return false;
    }


    /*
     * Prevent duplicate conversions
     * for the same email in this session.
     */

    if (
      hasAlreadySentSignup(email)
    ) {
      console.log(
        '[HJ Meta] CompleteRegistration already sent:',
        email
      );

      return false;
    }


    /*
     * Check Meta Pixel.
     */

    if (
      typeof window.fbq !== 'function'
    ) {
      console.warn(
        '[HJ Meta] Meta Pixel fbq() is not available'
      );

      return false;
    }


    /*
     * Generate unique event ID.
     */

    const eventId =
      'hj_signup_' +
      Date.now() +
      '_' +
      Math.random()
        .toString(36)
        .slice(2);


    /*
     * Custom event parameters.
     *
     * NOTE:
     * You specifically requested signup_email, so it
     * is included here.
     */

    const data = {

      signup_source:
        'Meta Source',

      signup_platform:
        attribution.source || 'meta',

      signup_medium:
        attribution.medium || '',

      signup_campaign:
        attribution.campaign || '',

      signup_email:
        email
    };


    console.log(
      '[HJ Meta] Sending CompleteRegistration',
      {
        email,
        attribution,
        data,
        eventId
      }
    );


    /*
     * Send event to Meta Pixel.
     */

    try {

      window.fbq(
        'track',
        'CompleteRegistration',
        data,
        {
          eventID: eventId
        }
      );


      markSignupAsSent(email);


      console.log(
        '[HJ Meta] CompleteRegistration sent',
        {
          email,
          eventId
        }
      );


      return true;

    } catch (error) {

      console.error(
        '[HJ Meta] CompleteRegistration failed',
        error
      );

      return false;
    }
  }


  /*
   * ============================================================
   * 8. PUBLIC API
   * ============================================================
   *
   * Provider integrations can call:
   *
   *      window.HJMetaTracking.trackSignup(email)
   *
   */

  window.HJMetaTracking = {

    trackSignup:
      trackMetaSignup,

    getAttribution:
      getMetaAdAttribution,

    isMetaAdVisit:
      isMetaAdVisit

  };


  /*
   * ============================================================
   * 9. ALIA FORM DETECTION
   * ============================================================
   *
   * We don't use Alia's generated IDs.
   *
   * We identify the form by the email input.
   * ============================================================
   */

  function isAliaSignupForm(form) {

    if (
      !(form instanceof HTMLFormElement)
    ) {
      return false;
    }

    const emailInput =
      form.querySelector(
        'input[name="email"][autocomplete="email"]'
      );

    return !!emailInput;
  }


  /*
   * ============================================================
   * 10. ALIA SUBMIT HANDLER
   * ============================================================
   *
   * Alia creates its popup dynamically, therefore
   * event delegation is used.
   *
   */

  document.addEventListener(
    'submit',
    event => {

      const form =
        event.target;


      if (
        !isAliaSignupForm(form)
      ) {
        return;
      }


      const emailInput =
        form.querySelector(
          'input[name="email"][autocomplete="email"]'
        );


      if (!emailInput) {
        return;
      }


      const email =
        emailInput.value
          ? emailInput.value.trim()
          : '';


      if (
        !email ||
        !isValidEmail(email)
      ) {
        console.log(
          '[HJ Alia] Invalid/empty email'
        );

        return;
      }


      console.log(
        '[HJ Alia] Signup form submitted:',
        email
      );


      /*
       * Give Alia time to process its submission.
       *
       * If Alia exposes a success callback later,
       * this can be changed to use that callback.
       */

      window.setTimeout(
        () => {

          window.HJMetaTracking.trackSignup(
            email
          );

        },
        1000
      );

    },
    true
  );


  /*
   * ============================================================
   * 11. ATTENTIVE SUCCESS HANDLER
   * ============================================================
   *
   * Attentive is loaded in a cross-origin iframe:
   *
   * creatives.attn.tv
   *
   * We therefore cannot access its DOM directly.
   *
   * Attentive sends postMessage events to the parent page.
   *
   * The captured data showed:
   *
   *      action: "LEAD"
   *      email: "..."
   *
   * so LEAD is used as the signup-success signal.
   *
   */

  window.addEventListener(
    'message',
    event => {

      /*
       * Only trust Attentive's creative origin.
       */

      if (
        event.origin !==
        'https://creatives.attn.tv'
      ) {
        return;
      }


      const attentive =
        event.data?.__attentive;


      if (!attentive) {
        return;
      }


      /*
       * Ignore OPEN / CLOSE / IMPRESSION /
       * RESIZE_FRAME / etc.
       */

      if (
        attentive.action !== 'LEAD'
      ) {
        return;
      }


      /*
       * Attentive LEAD contains the email.
       */

      const email =
        (
          attentive.email ||
          ''
        )
          .trim()
          .toLowerCase();


      if (!email) {

        console.warn(
          '[HJ Attentive] LEAD received without email',
          attentive
        );

        return;
      }


      console.log(
        '[HJ Attentive] LEAD received',
        {
          email,
          creativeId:
            attentive.creativeId,
          sourceUrl:
            attentive.sourceUrl
        }
      );


      /*
       * Send the same Meta conversion used by Alia.
       */

      window.HJMetaTracking.trackSignup(
        email
      );

    }
  );


  /*
   * ============================================================
   * 12. CAPTURE ATTRIBUTION ON PAGE LOAD
   * ============================================================
   */

  captureMetaAdAttribution();


  /*
   * ============================================================
   * 13. DEBUG
   * ============================================================
   */

  console.log(
    '[HJ Meta] Meta signup tracking initialized',
    {
      metaAdVisit:
        isMetaAdVisit(),

      attribution:
        getMetaAdAttribution(),

      metaPixelAvailable:
        typeof window.fbq === 'function'
    }
  );

})();